import { render, staticRenderFns } from "./SuccessStoriesDetails.vue?vue&type=template&id=97c80522"
import script from "./SuccessStoriesDetails.vue?vue&type=script&lang=js"
export * from "./SuccessStoriesDetails.vue?vue&type=script&lang=js"
import style0 from "./SuccessStoriesDetails.vue?vue&type=style&index=0&id=97c80522&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports